import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ImpersonationService } from '../services/impersonation.service';

/**
 * Adds the X-Impersonate header to outbound requests while an impersonation session is active.
 * The header is only a signal: each microservice still verifies the Redis entry keyed by the
 * authenticated caller's Azure AD oid before switching to the effective (impersonated) user.
 */
@Injectable()
export class ImpersonationInterceptor implements HttpInterceptor {
  constructor(private readonly impersonation: ImpersonationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.impersonation.isActive() || !this.isOwnApiRequest(req.url)) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({ setHeaders: { 'X-Impersonate': 'true' } }),
    );
  }

  /**
   * Only tag calls to our own backend (relative `/api/...`, matching the MSAL protectedResourceMap).
   * Never attach the header to third-party hosts such as Microsoft Graph.
   */
  private isOwnApiRequest(url: string): boolean {
    return url.startsWith('/api/') || url.startsWith('api/');
  }
}
